import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/services/api.service';
import { BibleBook } from 'app/modules/admin/components/bible-book/bible-book.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  private model: any;
  private error: string;

  public isSuccess: boolean = false;

  private loginStatus: number = 0;

  constructor(
    private route: ActivatedRoute,
    private apiSvc: ApiService
  ) { }

  ngOnInit() {

    this.loginStatus = 0;
    this.error = "";

    this.model = {};
 

    this.route.queryParams.subscribe(p=> {

      var code = p["code"];
      if (code == null) {
        //invalid request. Redirect to login
        alert("Invalid URL");
        return;
      }

      this.model.Code = code.replace(/\s/g, '+');
    });
    
  }

  public Save() {

    this.error = ""; 

    if (this.model.Email == "" || this.model.Email == null) {
      alert("Please provide your email address");
      return;
    }
 
    if (this.model.Password.length < 9) {
      alert("Your password must be at least 9 characters");
      return;
    }
  
    if (this.model.Password == "" || this.model.Password == null) {
      alert("Enter your new password");
      return;
    }

    if (this.model.Password != this.model.ConfirmPassword) {
      alert("The passwords do not match.");
      return;
    }
    

    this.loginStatus = 1;
    this.apiSvc.post("api/Account/ResetPassword/", this.model).subscribe(
      (data) => {
        console.log(data);  
        this.loginStatus = 0;
 
        this.isSuccess = true;
      },
      (err) => { 
        console.error(err); 

        this.error = "An unspecifed error occurred";

        if (err.Message != null) {

          this.error = err.Message;

          if (this.error == "Invalid token.") {
            this.error = "This URL is no longer valid. To reset your password, please request a new URL.";
          }

          if (err.ModelState != null) {
            console.log(err.ModelState);

            err.ModelState.forEach(element => {
              
              console.log(element);

              element.array.forEach(fieldError => {
                console.log(fieldError);
              });

            });

          }

        }

        this.loginStatus = 0;
      }
    );
  }

}
